<div class="min-h-screen bg-[#F5F5F5]">
	<div class="flex flex-col justify-between min-h-screen">
		<div>
			<ng-container *ngTemplateOutlet="header"></ng-container>
		</div>
		<div class="grow mx-[20px]">
			<ng-container *ngTemplateOutlet="body"></ng-container>
		</div>
		<div class="mx-[20px] pb-[40px]">
			<ng-container *ngTemplateOutlet="footer"></ng-container>
		</div>
	</div>
</div>


<ng-template #header>
    <ng-container *ngIf="useCustomMobileStepper else defaultStepper">
		<ng-container *ngTemplateOutlet="customStepper"></ng-container>
	</ng-container>
</ng-template>
<ng-template #body>
	<div class="flex flex-col bg-white gap-[24px] rounded-[8px] py-[20px] px-[16px] justify-center">
		<div class="grow">
			<app-kamona-otp idV2="otp" [version]="KamonaOtpVersion.version_2"
				(emitInput)="setOtp($event)" ></app-kamona-otp>
		</div>
		<div>
			<div class="bg-[#F2F7FE] items-center justify-between rounded-[8px] p-[12px] flex gap-[9px]">
				<div class="flex items-center gap-[9px]">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z" fill="#0361F0"/>
					</svg>
					<div class="text-[12px] text-black leading-[17.76px] font-normal">
						Didn’t get the code?
					</div>
				</div>
				<button (click)="handleOtpAction()" class="text-[#0361F0] justify-end cursor-pointer leading-[17.36px] text-[14px] font-medium disabled:text-[#999999]" [disabled]="showResendButtonCountDown">
					Resend
					<ng-container *ngIf="showResendButtonCountDown">
						<span class="inline-flex">
							(<span>
								{{formatTime(resendButtonCountDown?.minute)}}
							</span>
							<span>:</span>
							<span>
								{{formatTime(resendButtonCountDown?.second)}}
							</span>)
						</span>
					</ng-container>
				</button>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #footer>
	<div class="kamona-button-session pt-[24px]">
		<app-kamona-custom-button
			type="primary"
			[isSubmitting]="submitting"
			[isDisabled]="!(otp?.length === noOfPin)"
			(submitForm)="submit()"
			[isBlock]="true" [text]="btnText">
		</app-kamona-custom-button>
	</div>
</ng-template>

<ng-template #customStepper>
	<div class="pt-[27px] pb-[24px]">
		<div class="flex items-center mx-[20px]">
			<div class="basis-[32%]">
				<svg class="cursor-pointer" (click)="goBack()" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M21.5607 26.0607C20.9749 26.6464 20.0251 26.6464 19.4393 26.0607L10.4393 17.0607C9.85355 16.4749 9.85355 15.5251 10.4393 14.9393L19.4393 5.93934C20.0251 5.35355 20.9749 5.35355 21.5607 5.93934C22.1464 6.52513 22.1464 7.47487 21.5607 8.06066L13.6213 16L21.5607 23.9393C22.1464 24.5251 22.1464 25.4749 21.5607 26.0607Z" fill="#0361F0"/>
				</svg>
			</div>
			<div class="text-center basis-[36%] leading-[19.6px] text-[14px] font-semibold text-black">
				{{headerTitle}}
			</div>
			<div class="basis-[32%] flex justify-end">
				<div *ngIf="usesHelpButton" (click)="help.emit()"
				class="text-[#0361F0] leading-[19.6px] cursor-pointer font-medium text-[14px]">
					Need help?
				</div>
			</div>
		</div>
		<div class="py-[22px]">
			<ng-container *ngIf="useHeaderBorder else headerDivider">
				<svg width="375" height="1" viewBox="0 0 375 1" fill="none" xmlns="http://www.w3.org/2000/svg">
					<line x1="4.37114e-08" y1="0.5" x2="375" y2="0.500033" stroke="#E7EAF1"/>
				</svg>
			</ng-container>
		</div>
		<div class="flex flex-col gap-[8px] mx-[20px]">
			<div class="text-[20px] text-black leading-[24.8px] font-semibold">{{title}}</div>
			<div class="text-[12px] text-black leading-[17.76px] font-normal">{{description}}</div>
		</div>
	</div>
</ng-template>
<ng-template #headerDivider>
	<svg width="100%" height="3" viewBox="0 0 100% 3" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="100%" height="3" fill="#DBE7FD"/>
		<rect width="37" height="3" fill="#0357EE"/>
	</svg>
</ng-template>
<ng-template #defaultStepper>
	<app-mobile-timeline-template-v2
		(goBack)="goBack()"
		[previous]="previousTitle"
		[version]="version"
		[currentStep]="currentStep"
		[description]="description"
		[title]="title"
		[total]="totalStep">
	</app-mobile-timeline-template-v2>
</ng-template>

